import { useMutation, useQuery } from '@tanstack/react-query';
import { getErrorMessage } from '@tectonic/errors';
import {
  isEligibleForDelete,
  markUserForDelete,
} from '@tectonic/remix-client-network';
import { useToast } from '../../../core';

import type { ElemasonAccountDeleteWidget } from '@tectonic/types';

const useAccountDelete = (widget: ElemasonAccountDeleteWidget) => {
  const wData = widget.data!;
  const { showToast } = useToast();
  const { data: isDeleteAllowed, isLoading: isLoadingEligibility } = useQuery({
    queryKey: [],
    queryFn: async () => {
      const response = await isEligibleForDelete();
      return !!response.data?.isEligible;
    },
  });

  const { isPending: isMarkingForDelete, mutate: onDelete } = useMutation({
    mutationFn: async () => {
      const response = await markUserForDelete();
      if (response.error) {
        throw response.error;
      }
    },
    onSuccess: () => {
      globalThis.location.href = '/';
    },
    onError: (error) => {
      const message = getErrorMessage(error);
      showToast({ title: message });
    },
    mutationKey: [],
  });

  const isDeleting = isLoadingEligibility || isMarkingForDelete;

  const handleDelete = async () => {
    if (!isDeleteAllowed) {
      // eslint-disable-next-line no-alert
      window.alert(wData.notAllowedMessage);
    }
    onDelete();
  };

  return { isDeleting, handleDelete };
};

export { useAccountDelete };
